import { render, staticRenderFns } from "./ComingSoonDataIcon.vue?vue&type=template&id=ef2b49a0"
import script from "./ComingSoonDataIcon.vue?vue&type=script&lang=js"
export * from "./ComingSoonDataIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports